import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  selectConfirmationFormPayloadItem,
  selectConfirmationFormStatus,
} from '@cashier/cashier-data-access';
import { FormStatuses, ValidationStatuses } from '@cashier/cashier-model';

interface UseFormPayloadItem {
  isDisabled: boolean;
  validationStatus: ValidationStatuses;
  errors: string[];
}

export const useFormPayloadItem = (fieldName: string): UseFormPayloadItem => {
  const formStatus = useSelector(selectConfirmationFormStatus);
  const payloadItem = useSelector(selectConfirmationFormPayloadItem(fieldName));

  const {
    errors,
    validationStatus: payloadValidationStatus,
    interactionCompleted,
  } = payloadItem;

  const validationStatus: ValidationStatuses = useMemo(() => {
    if (
      !interactionCompleted &&
      payloadValidationStatus === ValidationStatuses.FAILED
    ) {
      return ValidationStatuses.UNDEFINED;
    }

    return payloadValidationStatus;
  }, [payloadValidationStatus, interactionCompleted]);

  return useMemo(
    () => ({
      isDisabled: formStatus === FormStatuses.SUBMITTED,
      validationStatus,
      errors,
    }),
    [formStatus, validationStatus, errors],
  );
};
